import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import moment from 'moment';
import getContractStatus from '../Purchasers/getContractStatus.api';
import * as DOCUMENT_NAMES from '../../constants/documentNames';

const firebaseRef = firebase.database();

export async function getUnitSoldForCurrentAgent(
	salesAgentId,
	filterByDate,
	callback
) {
	if (salesAgentId) {
		firebaseRef
			.ref('/kavtek_purchasers/' + PROJECT_CODE.projectCode)
			.orderByKey()
			.equalTo(salesAgentId)
			.on('value', async (snapshot) => {
				try {
					let purchasersParent = snapshot?.val();
					if (purchasersParent) {
						let purchasersKeys = [];
						let purchaserObj =
							purchasersParent &&
							purchasersParent[Object?.keys(purchasersParent)];
						purchasersKeys =
							purchaserObj && Object?.keys(purchaserObj);
						await firebaseRef
							.ref(
								'/kavtek_agreements/' + PROJECT_CODE.projectCode
							)
							.on('value', (snapshot) => {
								let agreementsParant = snapshot.val();
								if (agreementsParant) {
									let agreementsKeys =
										agreementsParant &&
										Object?.keys(agreementsParant);
									let filteredArr =
										purchasersKeys &&
										purchasersKeys.filter((value) =>
											agreementsKeys.includes(value)
										);
									let soldoutLotObj = getSoldoutLotObj(
										agreementsParant,
										filteredArr,
										filterByDate
									);
									callback(Object.values(soldoutLotObj));
								} else {
									callback([]);
								}
							});
					} else callback([]);
				} catch (err) {
					throw err.message;
				}
			});
	}
}

export async function getAllUnitSold(filterByDate, callback) {
	firebaseRef
		.ref('/kavtek_purchasers/' + PROJECT_CODE.projectCode)
		.on('value', async (snapshot) => {
			try {
				let purchasersParent = snapshot?.val();
				if (purchasersParent) {
					await firebaseRef
						.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode)
						.on('value', (snapshot) => {
							let purchasersArr = [];
							for (let agentKey in purchasersParent) {
								let purchaserChild = purchasersParent[agentKey];
								let purchaserChildKeys =
									Object.keys(purchaserChild);

								purchasersArr =
									purchasersArr.concat(purchaserChildKeys);
							}

							let agreementsParant = snapshot?.val();

							if (agreementsParant) {
								let agreementParentKeys =
									agreementsParant &&
									Object.keys(agreementsParant);
								let filteredArr = purchasersArr.filter(
									(value) =>
										agreementParentKeys.includes(value)
								);

								let soldoutLotObj = getSoldoutLotObj(
									agreementsParant,
									filteredArr,
									filterByDate
								);
								callback(Object.values(soldoutLotObj));
							} else {
								callback([]);
							}
						});
				} else {
					callback([]);
				}
			} catch (err) {
				console.log('⚠️ Error ⚠️: ' + err.message);
				throw err.message;
			}
		});
}

function getSoldoutLotObj(clients, clientsKeysArr, filterByDate) {
	try {
		let soldOutLotArr = [];
		let soldoutLotObj = {};

		let setDocsObjKeys = [];
		for (let i = 0; i < clientsKeysArr.length; i++) {
			let key = clientsKeysArr[i];
			if (clients[key]?.documentInformation?.documentStatus === 'sent') {
				getContractStatus({ leadId: key }, (returned) => {
					returned.name !== 'Cancelled' && setDocsObjKeys.push(key);
				});
			}
		}

		let lotArr = setDocsObjKeys
			.filter((key) => {
				let documentInfoObj = clients[key]?.documentInformation;
				let signatureRequestsObj = documentInfoObj?.signatureRequests;

				let signatureRequestsKeys;
				signatureRequestsKeys = Object.keys(signatureRequestsObj);
				let signatureRequestsKey;

				signatureRequestsKey = signatureRequestsKeys.filter(
					(key) =>
						signatureRequestsObj[key]['subject'] ===
						DOCUMENT_NAMES.aps
				);

				if (signatureRequestsKey) {
					let timestamp =
						signatureRequestsObj[signatureRequestsKeys[0]]
							?.timestamp;

					if (filterByDate === 'Month') {
						return moment(timestamp).isBetween(
							moment().subtract(1, 'months'),
							moment()
						);
					} else if (filterByDate === 'Week') {
						return moment(timestamp).isBetween(
							moment().subtract(7, 'days'),
							moment()
						);
					} else if (filterByDate === 'Today') {
						return moment(timestamp).isBetween(
							moment().startOf('day'),
							moment()
						);
					} else {
						return true;
					}
				} else {
					return false;
				}
			})
			.map((key) => {
				let lotId = clients[key]?.productAvailability?.lotId;
				let lotName = clients[key]?.productAvailability?.modelName;
				let elevationPrice =
					clients[key]?.productAvailability?.elevation?.price;
				let lotPrice = clients[key]?.productAvailability?.lotPrice;
				let totalMainFloor = clients[key]?.totalOptions;
				let totalCost =
					parseFloat(elevationPrice ? elevationPrice : 0) +
					parseFloat(lotPrice ? lotPrice : 0) +
					parseFloat(totalMainFloor ? totalMainFloor : 0);

				return { lotId, lotName, totalCost };
			})
			.filter((lot) => lot.lotId);
		lotArr.forEach((lot) => {
			soldOutLotArr.push(lot);
		});
		soldOutLotArr?.forEach((soldOutLot) => {
			if (!soldoutLotObj[soldOutLot.lotName]) {
				soldoutLotObj[soldOutLot.lotName] = {
					name: soldOutLot.lotName,
					number: 1,
					totalCost: Number(soldOutLot.totalCost),
				};
			} else {
				soldoutLotObj[soldOutLot.lotName].number++;
				soldoutLotObj[soldOutLot.lotName].totalCost += Number(
					soldOutLot.totalCost
				);
			}
		});
		return soldoutLotObj;
	} catch (err) {
		throw err.message;
	}
}
